module.exports = __webpack_public_path__ + "img/ruchki.d5274e3e.svg";